


export function button172_click(event) {
    $w('#wixChat1').maximize();
}